import { render, staticRenderFns } from "./MainSoftware.vue?vue&type=template&id=33669fad&scoped=true&"
import script from "./MainSoftware.vue?vue&type=script&lang=js&"
export * from "./MainSoftware.vue?vue&type=script&lang=js&"
import style0 from "./MainSoftware.vue?vue&type=style&index=0&id=33669fad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33669fad",
  null
  
)

export default component.exports